module.exports = __webpack_public_path__ + "./img/src/img/mobile_img/homepage_mobile_img-08.jpg";